import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectAfterMoveActionOption')(function selectAfterMoveActionOption(selection, state) {
    var optionState = state.optionState;
    optionState.nextSelection = selection;
}));
//# sourceMappingURL=selectAfterMoveActionOption.js.map